// Mobile menu drawer: <dialog> + two-level panels. No dependencies.
const dlg = document.querySelector('[data-mobile-menu]');
if (dlg) {
  const openers = [...document.querySelectorAll('[data-mobile-menu-open]')]; const openBtn = openers[0]; // header burger + bottom bar
  const panels = dlg.querySelector('[data-mobile-menu-panels]');
  const show = (id) => {
    panels?.querySelectorAll('[data-panel]').forEach((p) => { p.hidden = p.dataset.panel !== id; });
    dlg.querySelectorAll('[data-panel-open]').forEach((b) => b.setAttribute('aria-expanded', String(b.dataset.panelOpen === id)));
  };
  openers.forEach((b) => b.addEventListener('click', () => { dlg.showModal(); openers.forEach((o) => o.setAttribute('aria-expanded', 'true')); show('root'); }));
  dlg.addEventListener('close', () => openers.forEach((o) => o.setAttribute('aria-expanded', 'false')));
  dlg.querySelector('[data-mobile-menu-close]')?.addEventListener('click', () => dlg.close());
  dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  dlg.querySelectorAll('[data-panel-open]').forEach((b) => b.addEventListener('click', () => show(b.dataset.panelOpen)));
  dlg.querySelectorAll('[data-panel-back]').forEach((b) => b.addEventListener('click', () => show('root')));
}
